const news = {
    mixins: [mixins],
    data() {
        return {
            value: "",
            tabs: [],
            tab: "all",
            tabItem: null,
            handler: "",
            errorDialog: false,
            errorMsgs: [],
            records: [],
            recordsBelow: [],
            featuredNews: [],
            loading: true,
            page: 1,
            allItems: 0,
            finalallItems: 0,
        };
    },
    mounted() {},
    methods: {
        reset() {
            this.records = [];
            this.page = 1;
        },

        changeTab(newTab) {
            api.fn.moveWindowToObj(jQuery(".s-news"), 0, () => {
                this.$refs["tabs"].changeTab(newTab);
            });
        },

        tabChanged(newTab) {
            this.reset();

            this.tab = newTab;
            this.tabItem = this.tabs.filter((x) => x.id === newTab)[0];

            this.doSearch();
        },

        //make call and fetch data
        doSearch() {
            this.loading = true;
            this.errorMsgs = [];

            try {
                axios
                    .get(this.handler + "?value=" + this.tab + "&page=" + this.page + "&t=" + Math.floor(Date.now() / 1000))
                    .then((response) => {
                        var { hasError, errorMessages, data, allItems } = response.data;

                        if (hasError) {
                            this.handleError(errorMessages);
                            return false;
                        }

                        //get articles
                        var filteredData = data.filter((x) => x.featured == "false");

                        //get featured article
                        var feat = data.filter((x) => x.featured == "true");

                        this.handleSuccess(filteredData, allItems, feat);
                    })
                    .catch((errors) => {
                        this.handleError([errors]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            } catch (err) {
                this.loading = false;
                this.handleError(JSON.parse(err));
            }
        },

        //if server has errors show them
        handleError(messages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
            this.errorDialog = true;
        },

        //if server has not errors
        handleSuccess(filteredData, allItems, feat) {
            this.records = [];
            this.featuredNews = [];
            this.recordsBelow = [];

            this.$nextTick(() => {
                this.allItems = parseInt(allItems);

                this.records.concat(...filteredData);

                this.featuredNews = [].concat(...feat);

                //get articles up feattured article
                this.records = [].concat(...filteredData).slice(0, 4);

                //get articles below featured article
                this.recordsBelow = [].concat(...filteredData).slice(4);
            });
        },

        //when page change scroll up s-news div
        pageChanged(newPage) {
            this.page = newPage;

            this.doSearch();
            this.scrollToElem(jQuery(".s-news"));
        },
    },
    computed: {},
};

var newsApp = Vue.createApp(news);
if (document.querySelector("#v-news")) {
    newsApp.directive("init", initDirective);
    newsApp.component("b-tabs", bTabs);
    newsApp.component("b-pagination", bPagination);
    newsApp.component("alert-danger", alertDanger);
    newsApp.mount("#v-news");
}
